import { render } from "./ModalIndisponibilita.vue?vue&type=template&id=56436c7e&scoped=true"
import script from "./ModalIndisponibilita.vue?vue&type=script&lang=js"
export * from "./ModalIndisponibilita.vue?vue&type=script&lang=js"

import "./ModalIndisponibilita.vue?vue&type=style&index=0&id=56436c7e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-56436c7e"

export default script